/** 包裹表单数据 */
export interface IParcelFormValues extends ParcelFormFields {
  /** 重量 */
  parcel_weight?: string | number
  /** 单位 */
  parcel_weight_unit?: string
  /** 参考号 */
  parcel_order_no?: string
  /** 备注 */
  parcel_sender_remark?: string
  /** 单价币种 */
  parcel_currency_code?: string
  /** 转换后单价币种 */
  parcel_converted_currency_code?: string
  /** 币种切换 */
  parcel_check_currency?: boolean

  parcel_show_keys?: string[]
}

/** 初始化参数 */
export type IInitialParcel = {
  props: {
    /** 地址收货国家 */
    arrivalCountry?: string
    /** 发货国家 */
    senderCountry: string
    /** 订单原币种 */
    originCurrencyCode?: string

    /** 订单场景类型 1新建订单 2订单转运单 3运单编辑 */
    orderType: number
    /** 是否中国跨境 */
    isChinaCrossBorder?: boolean
    /** 是否跨境 */
    isCrossBorder?: boolean
    /** 是否中国发美国的德立讯订单 */
    isCN2US?: boolean
    /** 香港跨境 */
    isHKCrossBorder?: boolean
    /** 有无包裹商品信息， 没有下一步disabled */
    isReady?: boolean

    /** is ID local */
    IsIndonesia?: boolean
  }
  /** 订单||运单 format之后的表单值 */
  formValues?: IParcelFormValues
}

export type IUpdateProps = Pick<IInitialParcel, 'formValues'> & { cover?: boolean }
export interface InitialState {
  currencyInfo: CurrencyInfo
  props?: Partial<IInitialParcel['props']>
  errors?: Record<string, Array<{ errors: string[] }>>
}
export interface GetProductsRateParams {
  source?: string
  target?: string
  list?: ParcelFormFields['parcel_commodities']
}

export type CurrencyInfo = {
  // 原币种
  originCurrencyCode?: string
  // 转换过
  hasConverted?: boolean
  // 汇率版本
  fetchTime?: number
  // 当前汇率
  currencyRate?: number
}

/** 表单拥有的字段 */
export interface ParcelFormFields extends ParcelSizeFields {
  /** 包裹信息数组 */
  parcel_commodities?: Array<{
    /** 商品编码 */
    parcel_goods_code?: string
    /** 商品名 */
    parcel_goods_name?: string
    /** 数量 */
    parcel_goods_quantity?: number
    /**dd */
    parcel_goods_price?: number
    /** 中文品名 */
    parcel_goods_cname?: string
    /** 英文品名 */
    parcel_goods_ename?: string
    /** 海关编码 */
    parcel_goods_hscode?: string
    /** 商品材质 */
    parcel_goods_material?: string
    /** 商品用途 */
    parcel_goods_purpose?: string
    /** 商品规格 */
    parcel_goods_size?: string
    /** 转换后的价格 */
    parcel_goods_converted_price?: number
    /** 商品重量 */
    parcel_goods_weight?: number

    origin_country_code?: string
  }>
}
// 尺寸
export interface ParcelSizeFields {
  /** 长 */
  parcel_length?: string
  /** 宽 */
  parcel_width?: string
  /** 高 */
  parcel_height?: string
  parcel_length_unit?: string // 尺寸单位
}

export enum ORDER_TYPE {
  /** 订单创建 */
  ORDER_CREATE = 1,
  /** 订单转运单（编辑、发货 */
  ORDER_EDIT = 2,
  /** 运单编辑 */
  LOGISTICS_EDIT = 3,
}

export enum CurrencyConverted {
  CONVERTED = 1,
  NOT_CONVERT = 0,
  CANT_CONVERT = -1,
}
